export default {
      id: "address-usage",
      viewBox: "0 0 20 24",
      url: __webpack_public_path__ + "img/icons.svg#address",
      toString: function () {
        return this.url;
      }
    }